/** @file Clips the deform keys of one mesh to a vertex count (§5.2: start + values.length <= 2·count). */
import type { Draft } from 'immer';
import type { Doc, Id } from '@pose2d/format/types';
import type { CommandContext } from '../commandContext';

/** Truncates offsets past `2·count` in every animation (a key starting past the end becomes null); one INFO with the count. */
export function clipDeformKeys(draft: Draft<Doc>, id: Id, count: number, ctx: CommandContext): void {
  const limit = count * 2;
  let clipped = 0;
  for (const anim of Object.values(draft.animations)) {
    for (const key of anim.deform[id] ?? []) {
      const o = key.offsets;
      if (!o || o.start + o.values.length <= limit) continue;
      clipped++;
      key.offsets = o.start >= limit ? null : { start: o.start, values: o.values.slice(0, limit - o.start) };
    }
  }
  if (clipped > 0) ctx.warnings.push({ code: 'INFO', message: `clipped ${clipped} deform keys to the new vertex count`, params: { count: clipped }, path: 'vertices' });
}
